export default __webpack_public_path__ + "static/media/Asad.5d7c55bc.png";